import Grid from '@mui/material/Grid';
import { useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import RhfSelect from '../../../../libs/rhf-mui/RhfSelect';
import { Lang } from '../../../dao/SpwkUtil';
import { FrmSpwkQuestionnaire_Context } from '../index';

type Props = {}

const UcHeader = (props: Props) => {
  const mFrmView_Context = useContext(FrmSpwkQuestionnaire_Context);
  const rhf = useForm();

  function getData(data: any) {
    console.log(data);
  }

  return (

    <Grid item>
      <FormProvider {...rhf} >
        <form onSubmit={rhf.handleSubmit((data: any) => { getData(data) })}>
          <Grid container rowSpacing={{ xs: 2 }} columnSpacing={{ sm: 2 }} direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "center" }} justifyContent={{ sm: "center" }} mt={{ xs: 0 }}>
            <Grid item xs={12} sm={3}>
              <RhfSelect name="lang_A" label={"主語言"} options={[
                { value: "CHI", label: "中文" },
                { value: "ENG", label: "英文" },
                { value: "IND", label: "印尼" },
                { value: "TGL", label: "菲律賓" },
                { value: "VIE", label: "越南" },
                { value: "THA", label: "泰國" },
              ]}
                defaultValue="CHI"
                onChange={(e) => {
                  mFrmView_Context?.set_LangA(e.target.value as Lang);
                }}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <RhfSelect name="lang_B" label={"次語言"} options={[
                { value: "CHI", label: "中文" },
                { value: "ENG", label: "英文" },
                { value: "IND", label: "印尼" },
                { value: "TGL", label: "菲律賓" },
                { value: "VIE", label: "越南" },
                { value: "THA", label: "泰國" },
                { value: "", label: "無次語言" },
                { value: "RHF_NAME", label: "RHF" },
                { value: "CODE", label: "CODE" },
                { value: "HIS", label: "HIS" },
                { value: "GOV", label: "GOV" },
              ]}

                onChange={(e) => {
                  if (e.target.value === '無次語言') {
                    mFrmView_Context?.set_LangB('');
                  } else {
                    mFrmView_Context?.set_LangB(e.target.value as Lang);
                  }
                }}

                size="small"
              />
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </Grid >

  )
}

export default UcHeader